"use client";

import { getIcon } from "@litonarefin/utils/icons";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { getShareLinks } from "@litonarefin/utils/socialShare";

function SocialShare({ title }) {
  const [copiedText, setCopiedText] = useState({ copied: false });

  const pathname = usePathname();

  const socialPath = `${process.env.NEXT_PUBLIC_NEXTJS_SITE_URL}${pathname}`;
  const shareLinks = getShareLinks(socialPath, title);

  useEffect(() => {
    let interval;
    if (copiedText?.copied === true) {
      interval = setInterval(() => {
        setCopiedText({ copied: false });
      }, 6000);
    }
    return () => clearInterval(interval);
  }, [copiedText]);

  return (
    <div className="jlt-hidden md:jlt-block social-share">
      <div className="jlt-flex jlt-items-center jlt-gap-3">
        <CopyToClipboard
          text={`${process.env.NEXT_PUBLIC_NEXTJS_SITE_URL}${pathname}`}
          onCopy={() => setCopiedText({ copied: true })}
        >
          <button
            aria-label="Copy Post for Social Share"
            className={`jlt-border jlt-border-[#D0D5DD] jlt-py-1.5 jlt-px-2 jlt-rounded-[4px] jlt-text-xs jlt-flex jlt-items-center jlt-gap-2${
              copiedText?.copied ? " jlt-text-[#039855] jlt-font-bold" : " jlt-text-[#344054]"
            }`}
          >
            {copiedText?.copied ? <>{getIcon("check")}</> : <>{getIcon("copy")}</>}
          </button>
        </CopyToClipboard>

        <a
          target="_blank"
          rel="noopener noreferrer"
          href={shareLinks.facebook}
          className="jlt-border jlt-border-[#D0D5DD] jlt-p-1.5 jlt-rounded"
          aria-label="Facebook Share"
        >
          {getIcon("facebook")}
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={shareLinks.twitter}
          className="jlt-border jlt-border-[#D0D5DD] jlt-p-1.5 jlt-rounded"
          aria-label="Twitter/X Share"
        >
          {getIcon("twitter")}
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={shareLinks.linkedin}
          className="jlt-border jlt-border-[#D0D5DD] jlt-p-1.5 jlt-rounded"
          aria-label="Linkedin Share"
        >
          {getIcon("linkedin")}
        </a>
      </div>
    </div>
  );
}

export default SocialShare;
